import React from "react";
import {CredentialResponse, GoogleLogin} from "@react-oauth/google"
import {useMutation, useQuery} from "@apollo/client";

import {saveLoginToken} from "helpers/User";
import userLoginByGoogleToken from "graphql/User/mutation/userLoginByGoogleToken";
import userProfileQuery from "graphql/User/query/userProfile";

import './style.scss'

export const LoginForm = () => {

  const [mutate] = useMutation(userLoginByGoogleToken)
  const {refetch} = useQuery(userProfileQuery)

  const handleLogin = async (tokenId: string) => {
    const response = await mutate({
      variables: {
        token: tokenId,
      }
    })

    const {loginToken} = response?.data || {}
    const {token, expiration} = loginToken || {};

    saveLoginToken(token, expiration)
    refetch()
  }

  const handleGoogleLogin = async ({credential}: CredentialResponse) => {
    if (credential) {
      await handleLogin(credential)
    }
  }

  return <div className='login-container'>
    <h1>Connexion</h1>
    <div className="row justify-content-center">
      <div className="col-auto">
        <GoogleLogin
          onSuccess={handleGoogleLogin}
          onError={() => console.error("Google Login failed")}
        />
      </div>
    </div>
  </div>

}
